module.exports = __webpack_public_path__ + "img/delete-participant.ff5acf89.svg";